import HttpRequest from './HttpRequest';

export const getWorks = async () => {
  try {
    const response = await HttpRequest.get('/works');
    return response;
  } catch (err) {
    console.error(err);
    return null;
  }
};
